import Wishlist from './Wishlist';
import ModalWrapper from './ModalWrapper';
import { useDispatch, useSelector } from '../redux/hooks';
import { closeWishlist } from '../redux/slices/modalSlice';

const WishlistModal = () => {
  const wishlistOpen = useSelector((state) => state.modal.wishlistOpen);
  const dispatch = useDispatch();

  if (!wishlistOpen) return null;

  return (
    <ModalWrapper onClick={() => dispatch(closeWishlist())}>
      <div onClick={(e) => e.stopPropagation()}>
        <Wishlist />
      </div>
    </ModalWrapper>
  );
};

export default WishlistModal;